module.exports = __webpack_public_path__ + "img/chat-left-text-fill.87c225e6.svg";